import { ga, avocet } from 'js/analytics/adapters'
export const trackSelectGoal = ({ goal }) => {
  const props = {
    'Goal Type': goal,
  }
  ga.track('Select Goal', props)
  avocet.track('Select Goal', { goal })
}
